






import {Component, Prop, Vue} from 'vue-property-decorator'
import DingtalkLoginApi from "@/module/dingtalk/login/DingtalkLoginApi";
import _ from 'lodash'

@Component({})
export default class DingtalkLogin extends Vue {

    @Prop() protected appKey!: string
    @Prop() protected callback!: ((code: string) => void) | null

    private created() {
        this.qrcode()
        this.listener()
        this._callback()
    }

    private async qrcode() {
        await this.$nextTick()
        DingtalkLoginApi.qrcode({
            goto: encodeURIComponent(`https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${this.appKey}&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=${window.location.href}`)
        })
    }

    private listener() {
        const handleMessage = async (event: any) => {
            if (event.origin == "https://login.dingtalk.com") {
                const loginTmpCode = event.data;
                window.location.href = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${this.appKey}&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=${window.location.href}&loginTmpCode=${loginTmpCode}`
            }
        };

        if (typeof window.addEventListener != 'undefined')
            window.addEventListener('message', handleMessage, false);
        else if (
            // @ts-ignore
            typeof window.attachEvent != 'undefined'
        )
            // @ts-ignore
            window.attachEvent('onmessage', handleMessage);
    }

    private _callback() {
        const code = this.$route.query.code as string
        if (_.isEmpty(code)) return
        if (this.callback != null)
            this.callback(code)
    }
}
